import { loadableReady } from "@loadable/component";

import { Store, getMetadata, Tags, AdobeManager } from "@inferno/renderer-shared-core";

declare global {
  interface Window {
    __PRELOADED_STATE__: any;
  }
}

loadableReady(async () => {
  // Grab the state from a global variable injected into the server-generated HTML
  const preloadedState = window.__PRELOADED_STATE__;
  // Allow the passed state to be garbage-collected
  delete window.__PRELOADED_STATE__;

  const store = new Store(preloadedState);

  getMetadata({ store, isAmp: true });
  const tagState: Tags = store.tags;
  if (tagState.analytics?.view) {
    store.storeTags({
      ...tagState,
      analytics: {
        ...tagState.analytics,
        view: {
          ...tagState.analytics.view,
          contentFrame: "AMP",
        },
      },
    });
  }

  const adobe = new AdobeManager(store);
  adobe.trackPageView();
});
